import { Icon } from '@aibees/shared/components';
import { usePaymentStatus } from '@aibees/shared/hooks/payment/use-payment-status';
import { useBoolean } from '@aibees/shared/hooks/use-boolean';
import { classnames } from '@aibees/shared/utils';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import { memo } from 'react';
import { UpdatePaymentMethodDialog } from '../update-payment-method-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentFailedAlertProps as Props } from './types';

export const PaymentFailedAlert = memo(({ className }: Props) => {
  const { paymentFailed } = usePaymentStatus();
  const dialogState = useBoolean();

  if (!paymentFailed) return null;

  return (
    <Styled.Wrapper
      className={classnames('PaymentFailedAlert', className)}
      sx={SX.root}
    >
      <Alert
        severity="error"
        icon={<Icon name="credit-card-outlined" size={20} />}
        sx={SX.alert}
        action={
          <Button
            variant="outlined"
            size="small"
            color="default"
            onClick={dialogState.onTrue}
            startIcon={<Icon name="credit-card-add" size={20} />}
          >
            Update Payment Method
          </Button>
        }
      >
        <AlertTitle>Payment Method Failed</AlertTitle>
        <Box sx={SX.body}>
          <Typography variant="body3">
            We couldn&apos;t process your payment. This may be due to an issue
            with your card. Update your default payment method or add a new card
            to restore automatic billing.
          </Typography>
        </Box>
      </Alert>

      <UpdatePaymentMethodDialog
        open={dialogState.value}
        onClose={dialogState.onFalse}
      />
    </Styled.Wrapper>
  );
});

PaymentFailedAlert.displayName = 'PaymentFailedAlert';
